import type { FC } from "react"
import { useState } from "react"

import styled from "styled-components"

import { getPowurUrl } from "~/utils/getUrlForEnvironment"

import { ReactComponent as XIcon } from "@svg/x.svg"

import { useRejectDesignRequest } from "../../Proposal/state/design-request/use-design-request"
import {
  CharsLeft,
  Header,
  Info,
  Wrapper,
} from "../DesignSwitcher/FloatingBar/styles"

export const Buttons = styled.div`
  display: flex;
  gap: var(--space-xs);
  justify-content: space-evenly;
  > button {
    font-size: var(--step--2);
    margin: auto;
    border: 1px solid var(--dark);
    color: var(--dark);
    padding: 0 var(--space-m);
    height: 45px;
    border-radius: 7px;
    text-transform: capitalize;
    cursor: pointer;
    :first-of-type {
      border: 1px solid var(--blue);
      background-color: var(--blue);
      color: white;
    }
  }
`

export const Reject: FC<{
  close: VoidFunction
  reqId?: string
}> = ({ close, reqId }) => {
  const [message, setMessage] = useState<string>(``)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (e.target.value.length <= 255) setMessage(e.target.value)
  }
  const { reject, mutation } = useRejectDesignRequest()
  const handleSave = async () => {
    if (!reqId) return
    if (message.length === 0) return
    setIsLoading(true)
    await reject(reqId, message)
    close()
    window.location.assign(`${getPowurUrl()}/admin-solar-proposals/vision`)
  }

  return (
    <Wrapper isSaving={isLoading}>
      <Header>
        <h1 data-testid="reject-request-header">Reject Request</h1>
        <XIcon onClick={close} />
      </Header>
      <textarea value={message} onChange={handleChange} />
      <Info>
        {message.length === 0 ? (
          <p style={{ color: `var(--danger)` }}>
            Please enter a reason for rejecting this request
          </p>
        ) : (
          <p>The maximum allowed number of characters is 255</p>
        )}
        <CharsLeft>{255 - message.length} left</CharsLeft>
      </Info>
      <Buttons>
        <button onClick={handleSave}>Reject</button>
        <button onClick={close}>Cancel</button>
      </Buttons>
    </Wrapper>
  )
}
